import { 
  getLabels, 
  getOptionsLabel, 
  getUnitMap 
} from '@@/utils/getFields'
import { 
  isShowPcbParams, 
  validatePcbQuote 
} from '@@/utils/pcbQuoteFormat'

const FR_4_FIELDS = [
  {
    title: 'PCB文件',
    list: [ 'pcbfile' ]
  },
  {
    title: '基本信息',
    list: ['board_type', 'blayer', 'blind', 'board', 'pbnum', 'units', 'delivery_sub_units', 'length', 'layout', 'bcount', 'sidewidth']
  },
  {
    title: '工艺信息',
    list: ['bheight', 'copper', 'insidecopper', 'lineweight', 'vias', 'color', 'charcolor', 'cover', 'via_in_pad', 'spray', 'cjh', 'overlay_type', 'impendance', 'pressing', 'beveledge', 'bankong', 'baobian', 'press_fit_hole', 'test']
  },
  {
    title: '个性化服务',
    list: ['review_file', 'has_period', 'period_format', 'user_stamp', 'cross_board', 'eq_notice', 'engineer_id', 'lack_handle_type', 'insurance_type', 'report', 'report_type', 'paper', 'inner_box_label', 'label_remark', 'hq_pack', 'sh', 'orderman_id', 'note']
  },
  {
    title: '生产周期',
    list: ['deltime']
  },
  {
    title: '地址 / 快递',
    list: ['fh', 'fhp', 'aid', 'express']
  },
  {
    title: '发票 / 支付',
    list: ['invoice', 'bill_id', 'invoice_code', 'deduct_type']
  },
  { 
    title: 'SMT贴片', 
    list: ['is_need_smt'] 
  }
]
const ROGERS_FIELDS = [
  {
    title: 'PCB文件',
    list: [ 'pcbfile' ]
  },
  {
    title: '基本信息',
    list: ['board_type', 'hybrid_type', 'blayer', 'board_model', 'pbnum', 'units', 'delivery_sub_units', 'length', 'layout', 'bcount', 'sidewidth']
  },
  {
    title: '工艺信息',
    list: ['bheight', 'copper', 'insidecopper', 'lineweight', 'vias', 'color', 'charcolor', 'cover', 'via_in_pad', 'spray', 'cjh', 'overlay_type', 'impendance', 'pressing', 'beveledge', 'bankong', 'baobian', 'press_fit_hole', 'blue_glue', 'carbon_oil', 'test']
  },
  {
    title: '个性化服务',
    list: ['review_file', 'has_period', 'period_format', 'user_stamp', 'cross_board', 'eq_notice', 'engineer_id', 'report', 'report_type', 'paper', 'label_remark', 'hq_pack', 'sh', 'orderman_id', 'note']
  },
  {
    title: '生产周期',
    list: ['deltime']
  },
  {
    title: '地址 / 快递',
    list: ['fh', 'fhp', 'aid', 'express']
  },
  {
    title: '发票 / 支付',
    list: ['invoice', 'bill_id', 'invoice_code', 'deduct_type']
  },
  { 
    title: 'SMT贴片', 
    list: ['is_need_smt'] 
  }
]
const ALU_FIELDS = [
  {
    title: 'PCB文件',
    list: [ 'pcbfile' ]
  },
  {
    title: '基本信息',
    list: ['board_type', 'aluminium_board_type', 'blayer', 'board', 'pbnum', 'units', 'delivery_sub_units', 'length', 'layout', 'bcount', 'sidewidth']
  },
  {
    title: '工艺信息',
    list: ['bheight', 'copper', 'heat_factor', 'withstand_value', 'lineweight', 'vias', 'color', 'charcolor', 'cover', 'spray', 'cjh', 'forming_method', 'countersunk_hole', 'test']
  },
  {
    title: '个性化服务',
    list: ['review_file', 'has_period', 'period_format', 'user_stamp', 'cross_board', 'eq_notice', 'engineer_id', 'report', 'report_type', 'paper', 'label_remark', 'hq_pack', 'sh', 'orderman_id', 'note']
  },
  {
    title: '生产周期',
    list: ['deltime']
  },
  {
    title: '地址 / 快递',
    list: ['fh', 'fhp', 'aid', 'express']
  },
  {
    title: '发票 / 支付',
    list: ['invoice', 'bill_id', 'invoice_code', 'deduct_type']
  },
  { 
    title: 'SMT贴片', 
    list: ['is_need_smt'] 
  }
]
const COPPER_FIELDS = [
  {
    title: 'PCB文件',
    list: [ 'pcbfile' ]
  },
  {
    title: '基本信息',
    list: ['board_type', 'copper_board_type', 'blayer', 'board_tg', 'pbnum', 'units', 'delivery_sub_units', 'length', 'layout', 'bcount', 'sidewidth']
  },
  {
    title: '工艺信息',
    list: ['bheight', 'copper', 'insidecopper', 'copper_structure', 'heat_factor', 'lineweight', 'vias', 'color', 'charcolor', 'cover', 'spray', 'cjh', 'forming_method', 'countersunk_hole', 'test']
  },
  {
    title: '个性化服务',
    list: ['review_file', 'has_period', 'period_format', 'user_stamp', 'cross_board', 'eq_notice', 'engineer_id', 'report', 'report_type', 'paper', 'label_remark', 'hq_pack', 'sh', 'orderman_id', 'note']
  },
  {
    title: '生产周期',
    list: ['deltime']
  },
  {
    title: '地址 / 快递',
    list: ['fh', 'fhp', 'aid', 'express']
  },
  {
    title: '发票 / 支付',
    list: ['invoice', 'bill_id', 'invoice_code', 'deduct_type']
  },
  { 
    title: 'SMT贴片', 
    list: ['is_need_smt'] 
  }
]

export const showFields = (board_type = 'FR-4') => {
  return {
    'FR-4': FR_4_FIELDS,
    'ROGERS': ROGERS_FIELDS,
    'ALU': ALU_FIELDS,
    'COPPER': COPPER_FIELDS
  }[board_type] || []
}

// 合并显示的字段
const getShowFields = (board_type) => { 
  return showFields(board_type).reduce((acc, cur) => {
    return [...acc, ...cur.list]
  }, [])
}

/**
 * 字段显示格式化
 * @returns {Object} 
 * [key]: {
 *   label: 字段名称,
 *   value: 字段值,
 *   show: 字段是否显示,
 *   error: 字段检验是否没通过,
 *   tips: 字段检验没通过提示语,
 * }
 */
export const fieldsFormat = (params) => {
  const board_type = params.board_type
  const types = { 
    'FR-4': ['FR-4'], 
    'FPC': ['FPC'], 
    'ROGERS': ['FR-4', 'ROGERS'],
    'ALU': ['FR-4', 'ALU'],
    'COPPER': ['FR-4', 'COPPER'],
  }[board_type]
  // 根据字段key获取选项对应的值
  const getValueByKey = key => getOptionsLabel(types, key, params[key])

  // 字段名称：{ [field]: 字段名称 }
  const labels = {
    ...getLabels(types),
    length: params.units == 3 ? '连片尺寸' : '单片尺寸',
    deltime: '生产周期',
    bill_id: '抬头',
    invoice_code: '税号',
  }
  // 字段单位：{ [field]: 字段单位 }
  const units = getUnitMap(types)
  // 字段值：{ [field]: 字段值 }
  const valuesByOptions = getShowFields(board_type)
    .reduce((acc, key) => {
      acc[key] = getValueByKey(key)
      return acc
    }, {})

  // 字段是否显示
  const isShow = isShowPcbParams(params)
  const getFieldShow = (key) => {
    // 抬头/税号显示条件相同
    if (key === 'invoice_code') {
      return isShow.bill_id
    }
    return isShow[key] === undefined || isShow[key]
  }

  // 字段是否检验通过: { error: true | false, tips: 错误提示语 }
  const validates = validatePcbQuote(params)
  const getFieldValid = (key) => {
    const valid = validates.find(item => item.key === key)
    if (valid) {
      return { error: valid.flag, tips: valid.tips }
    }
    return { error: false, tips: '' }
  }

  // 工艺边框处理
  const sidewidthFormat = () => {
    if (params.sidedirection === '无') return '无'
    if (params.dfm_sets) {
      return `上: ${params.side_width_top}, 下: ${params.side_width_bot}, 左: ${params.side_width_left}, 右: ${params.side_width_right}`
    }
    return `${getOptionsLabel(types, 'sidewidth', params.sidedirection)}，${params.sidewidth || '--'} mm`
  }
  // 字段值格式化
  const format = {
    // PCB文件
    pcbfile: (params.pcbfile || '').split('/').pop(),
    // 板子层数
    blayer: `${params.blayer || '--'} 层`,
    // 板材
    board: params.view_board || '--',
    // 拼版款数
    pbnum: params.pbnum || '--',
    // 单片尺寸
    length: `${params.length || '--'}x${params.width || '--'} cm`,
    // 拼版规则
    layout: `${params.layoutx || '--'}x${params.layouty || '--'} Pcs`,
    // 单片数量
    bcount: params.bcount || '--',
    // 工艺边框
    sidewidth: sidewidthFormat(),
    // 板子厚度
    bheight: `${params.bheight || '--'} mm`,
    // 最小线宽线距
    lineweight: `${getValueByKey('lineweight')} ${units.lineweight}`,
    // 最小孔径
    vias: `${getValueByKey('vias')} ${units.vias}`,
    // 层压顺序
    overlay_type: `${getValueByKey('overlay_type')}${params.overlay_type == 3 ? '，' + params.overlay_seq : ''}`,
    // 叠层结构
    pressing: params.pressing.includes('__') ? params.pressing.split('__')[1] : params.pressing,
    // 测试方式
    test: params.view_test || (params.test === '样品免费测试' ? '样品免费' : params.test),
    // 工程师信息
    engineer_id: params.view_engineer_id || '',
    // 产品报告
    report: (params.report || []).join('，'),
    // 内包装标签备注
    label_remark: params.label_remark || '',
    // 下单人
    orderman_id: `${params.orderman}，${params.ordertel}`,
    // PCB订单备注
    note: params.note || '',
    // 生产周期
    deltime: params.standard_deltime || params.deltime || '',
    // 送货单
    fhp: `${getValueByKey('fhp')} ${params.fhp == 1 ? params.fhd_title : ''}`,
    // 收货地址
    aid: params.address || '',
    // 快递公司
    express: params.view_express || '',
    // 抬头
    bill_id: params.view_invoice_title || '',
    // 税号
    invoice_code: params.view_invoice_code || '',
  }

  // 统一处理是否显示和校验
  const fieldsData = Object.entries({ ...valuesByOptions, ...format })
    .reduce((acc, [key, value]) => { 
      acc[key] = {
        key,
        value,
        label: labels[key],
        show: getFieldShow(key),
        ...getFieldValid(key)
      }
      return acc
    }, {})
  
  return fieldsData
}